import { render, staticRenderFns } from "./V2CartSearchSaveClearSection.vue?vue&type=template&id=19855c45&scoped=true&"
import script from "./V2CartSearchSaveClearSection.vue?vue&type=script&lang=js&"
export * from "./V2CartSearchSaveClearSection.vue?vue&type=script&lang=js&"
import style0 from "./V2CartSearchSaveClearSection.vue?vue&type=style&index=0&id=19855c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19855c45",
  null
  
)

export default component.exports